// extracted by mini-css-extract-plugin
export default {"logo":"sidebar_logo__iI966","menuContainer":"sidebar_menuContainer__rdIMd"};